import { createContext, useContext, useState } from 'react';

export const AuthContext = createContext(null)

export const AuthProvider = ({children}) => {

    const [user, setUser] = useState(null);

    const login = user => {
        var pk = user.pk
        var username = user.username
        var first_name = user.first_name
        var last_name = user.last_name
        var email = user.email
        var role = user?.role?.map(role=> role.role_name)
        var permissions = user.permissions
        var joined_date = user.joined_date
        var update_date = user.update_date
        var is_active = user.is_active
        var is_staff = user.is_staff

        setUser({ pk: pk, username: username, first_name: first_name, 
            last_name: last_name, role:role, permissions: permissions, email: email, joining_data: joined_date, profile_update_date: update_date, is_active: is_active, is_staff: is_staff  
        })
      
    };

    // Logout updates the user data to default
    const logout = () => {
        setUser(null)
    };

    return (
        <AuthContext.Provider value={{ user, login, logout }}>
        {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => {
    return useContext(AuthContext)
}
